<template>
  <div>
    <div style="float:right">
      <Dropdown
        trigger="click"
        placement="bottom-end"
        @on-click="setLocale"
      >
        <a
          href="javascript:void(0)"
          class="uk-link-text"
        >
          <div layout="center-left">
            <div
              :class="flag(locale)"
              self="center"
              style="margin-top:2px;"
              class="flag-icon"
            />
            <div
              self="center"
              style="margin: 0 5px;font-weight:bold;"
            >
              {{ locale }} &mdash; {{ languages[locale] }}
            </div>
            <div>
              <Icon type="arrow-down-b" />
            </div>
          </div>
        </a>
        <DropdownMenu
          slot="list"
          class="dropdown-flags"
        >
          <DropdownItem
            v-for="(item, key) in languages"
            :name="key"
            :selected="key===locale"
            :key="key"
          >
            <span
              :class="flag(key)"
              class="flag-icon"
            />
            &nbsp;&nbsp;{{ item }}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <div class="uk-clearfix" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      languages: state => state.store.languages,
      locale: state => state.store.locale
    })
  },
  methods: {
    async setLocale (locale) {
      const payload = await this.$store.dispatch('setLocale', locale)
      this.$emit('on-locale-changed', payload)
    },
    flag (lang) {
      if (lang === 'en') {
        return 'flag-icon-gb'
      } else {
        return 'flag-icon-' + lang
      }
    }
  }
}
</script>
<style>
  ul.ivu-dropdown-menu.dropdown-flags {
    width: 450px;
  }
  ul.ivu-dropdown-menu.dropdown-flags li.ivu-dropdown-item  {
    width: 150px;
    display: inline-block;
  }

  .uk-link-text:hover {
    text-decoration: none;
  }

</style>
